import { useSelector } from "react-redux";
import { buildApiHeaders } from "../helpers/apiHeaders.helper";
import { useMemo } from "react";

/**
 * React hook to get dynamic API headers for OSD APIs using Redux state and exception data.
 * @param options Optional overrides for tab, activeTerminal, exception, sectionName
 * @returns Headers object
 */
export function useApiHeaders(options?: {
  exception?: Partial<{ osdNumber: number|string, origin: string, destination: string, reporting: string }>;
  sectionName?: string;
  osdType?: string;
  osdNumber?: number|string;
}) {
  // Get from Redux if not provided
  const { activeTerminal: reduxTerminal, tab: reduxTab } = useSelector((state: any) => ({
    activeTerminal: state.activeTerminal,
    tab: state.tabPosition,
  }));
 return useMemo(
    () =>
      buildApiHeaders({
        tab: reduxTab,
        activeTerminal: reduxTerminal,
        exception: options?.exception,
        sectionName: options?.sectionName,
        osdType: options?.osdType,
        osdNumber: options?.osdNumber,
      }),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
      reduxTab,
      reduxTerminal,
      options?.sectionName,
      options?.osdType,
      options?.osdNumber,
      // Spread exception fields individually to avoid object reference instability
      options?.exception?.osdNumber,
      options?.exception?.origin,
      options?.exception?.destination,
      options?.exception?.reporting,
    ]
  );
}
